import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { FormStyle, getLocaleMonthNames, TranslationWidth } from '@angular/common';
import * as moment from "moment";
import { Status } from 'src/app/models/statusEnums';
import { CalendarEvent, Location, ObjectCalendarEvent, Type } from 'src/app/shared/model/models';
import { ObjectCalendarEventService, LocationService, CalendarEventService } from 'src/app/shared/api/api';
import { MessageService } from 'primeng/api';
import { FormGroupDirective } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { AccountService } from 'src/app/accounts/accountService';
import { LeadService } from 'src/app/leads/leadService';
import { OpportunityService } from 'src/app/opportunities/opportunity.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { FileUpload } from 'primeng/fileupload/fileupload';
import { uploadFiles, validateFiles } from '../../../../../app/shared/upload-files';
import { checkValidEmail } from '../../helpers/check-valid-email.helper';
import { environment } from 'src/environments/environment';
import { SharedColumnSettingsService } from '../../services/column-settings.service';
import { ColumnSettingsN } from '../../models/column-settings.model';
import { ParseHelper } from '../../parse.helper';
import { ChannelN } from '../../models/channel.model';
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from '../../constants/modules.constant';
import { SharedChannelService } from '../../services/channel.service';
import { Subject, takeUntil } from 'rxjs';
import { ActivityService } from '../shared-activities/activity.service';

@Component({
  selector: 'app-lion-shared-events',
  templateUrl: './shared-events.component.html',
  styleUrls: ['./shared-events.component.scss'],
  providers: [ObjectCalendarEventService, LocationService, CalendarEventService]
})
export class LionSharedEventsComponent implements OnInit, OnChanges {

  @Input() displayAddEvent;
  @Input() usersInCalendar;
  @Input() isUserCalendar;
  @Input() event?: ObjectCalendarEvent;
  @Input() isViewMode = false;
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();
  @Output() completeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onCompletedSaveEvent = new EventEmitter();
  @ViewChild('createEvent') createEvent: FormGroupDirective;

  @Input() objectTypeId: number = AccountModuleId;
  @Input() objectId: number = 0;
  @Input() selectedChannel;
  @Input() selectedObject;
  @Input() source: string = '';
  @Input() dateSelectionForCalendar: Date;
  @Input() mode?: string = "add";
  headerTitle;
  startDate: Date;
  startTime: Date;
  endDate: Date;
  endTime: Date;
  disableTime = false;
  minimumDate: Date;
  message: string;
  emailMsg: string;
  repeats: Type[] = [];
  repeatCustom = [
    { name: 'Daily', value: 'daily' },
    { name: 'Weekly', value: 'weekly' },
    { name: 'Monthly', value: 'monthly' },
    { name: 'Yearly', value: 'yearly' }
  ];
  selectedRepeat: Type;
  selectedCustomRepeat: any = null;
  dayNumbers = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5', value: '5' },
    { name: '6', value: '6' },
    { name: '7', value: '7' },
  ]
  selectedDayNumber;
  weekNumbers = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' }
  ]
  selectedWeekNumber;
  monthWeeks = [
    { name: 'first', value: 'first' },
    { name: 'second', value: 'second' },
    { name: 'third', value: 'third' },
    { name: 'forth', value: 'forth' }
  ]
  selectedMonthWeek;
  selectedWeek;
  selectedYear;
  selectedYearMonth;
  selectedYearMonth2;
  selectedYearCount;
  selectedYearWeek;
  monthDay1: number = 1;
  monthDay2: number = 1;
  yearNumbers = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' }
  ]
  selectedYearNumber;
  selectedDay;
  selectedMonth;
  selectedEnd;
  counts = [
    { name: '5', value: '5' },
    { name: '10', value: '10' },
    { name: '15', value: '15' },
    { name: '20', value: '20' },
    { name: '25', value: '25' },
  ]
  selectedCount;
  reminders = [
    { name: '0 minutes', value: 0 },
    { name: '5 minutes', value: 5 },
    { name: '10 minutes', value: 10 },
    { name: '15 minutes', value: 15 },
    { name: '30 minutes', value: 30 },
    { name: '1 hour', value: 60 },
    { name: '2 hours', value: 120 },
    { name: '3 hours', value: 180 },
    { name: '4 hours', value: 240 },
    { name: '8 hours', value: 480 },
    { name: '1 day', value: 1440 },
    { name: '2 days', value: 2880 },
    { name: '3 days', value: 4320 },
    { name: '1 week', value: 10080 },
    { name: '2 weeks', value: 20160 }
  ];
  selectedReminder = { name: '30 minutes', value: 30 };
  monthNames;
  selectedYearlyMonth = { label: "January", value: 1 };
  days = [];
  allDay = false;
  selectedMonthlyDay = { label: 1, value: 1 };
  selectedYearlyDay = { label: 1, value: 1 };
  showMessage = false;
  evtMsg = "";
  weekDays = [
    { name: "Monday", checked: false, value: 1 },
    { name: "Tuesday", checked: false, value: 2 },
    { name: "Wednesday", checked: false, value: 3 },
    { name: "Thursday", checked: false, value: 4 },
    { name: "Friday", checked: false, value: 5 },
    { name: "Saturday", checked: false, value: 6 },
    { name: "Sunday", checked: false, value: 0 }
  ];
  eventTitle = "";
  eventDescription = "";
  selectedWeekDays = [];
  usersList = [];
  isShown: boolean = false;
  displayCustom = false;
  duration = []
  color: string = '#1976D2';
  tempAttatchment = [{id:1,name:"panda.jpg",url: `${environment.assestsBasePath}images/panda.jpg`},
    {id:1,name:"test.doc",url: `${environment.assestsBasePath}images/panda.jpg`}];

    //#region EventPayload
  eventTemp: ObjectCalendarEvent = {
    "id": 0,
    "createdSource": this.app.userIP,
    "createdBy": this.app.user.userId,
    "createdDate": new Date(),
    "objectId": null,
    "objectTypeId": null,
    "calendarEventId": 0,
    "channelId": null,
    "calendarEvent": {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "name": "",
      "description": "",
      "organizationId": this.app.user.organizationId,
      "startDate": null,
      "endDate": null,
      "locationId": 0,
      "location": "",
      "userId": 0,
      "timeZoneId": 0,
      "colorCodeId": null,
      "seriesId": "",
      "syncDate": new Date(),
      "reminderInMinutes": 0,
      "calendarEventAttendees": [],
      "onlineMeetingProvider": "",
      "isOnlineMeeting": false,
      "isAllDay": false,
      "repeatTypeId": null,
      "isRecurring": true,
      "statusId": Status.Active,
      "typeId": null,
      "groupId": null,
      "isValid": true,
      "validFromDate": null,
      "validToDate": null,
      "eventColorCode": '',
      "occurrences": [
        {
          "id": 0,
          "createdSource": this.app.userIP,
          "createdBy": this.app.user.userId,
          "createdDate": new Date(),
          "calendarEventId": 0,
          "dayOfWeek": null,
          "weekOfMonth": null,
          "dayOfMonth": null,
          "monthOfYear": null,
          "maxNoOfOccurrence": null,
          "seperationCount": null,
          "statusId": Status.Active,
          "typeId": null,
          "groupId": null,
          "isValid": true,
          "validFromDate": null,
          "validToDate": null
        }
      ],
      "eventAttachments": [
        {
          "id": 0,
          "name": '',
          "contentType": '',
          "contentBytes": '',
          "downloadLink": '',
          "extension": '',
          "vendorAttachementId": ''
        }
      ],
      "vendorUserId": 0,
      "recurrence": null
    }
  }

  allAccountsName = [];
  allLeadName = [];
  allOpportunityName = [];
  allAssociationNamesList = [];
  associationNames = [];
  taskModules = [];

  locations: Location[];
  selectedLocation: Location;
  showValidation: boolean = false;
  disableSubmitButton = false;
  allUsersList: any[];
  tempReccurringEvent: any = {
    "id": 0,
    "createdSource": "",
    "updatedSource": "",
    "createdBy": this.app.user.userId,
    "updatedBy": this.app.user.userId,
    "createdDate": new Date(),
    "updatedDate": new Date(),
    "calendarEventId": 0,
    "daysOfWeek": "string",
    "dayOfMonth": 0,
    "monthOfYear": 0,
    "maxNoOfOccurrence": 0,
    "interval": 1,
    "firstDayOfWeek": "",
    "index": "",
    "startDate": null,
    "endDate": null,
    "statusId": 1,
    "repeatTypeId": 0,
    "reminderInMinutes": 0,
    "calenderEventStartDate": null,
    "calenderEventEndDate": null
  }
  yearDay: any;
  timezones: any;
  selectedtimeZone;
  requiredCalendarEventAttendees = [];
  optionalCalendarEventAttendees = [];
  storedCalendarAttendees: any[] = [];
  allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif']; // For the attachment files
  files: any[] = [];
  eventAttachments: any[] = [];
  eventAttachmentsVM: any[] = [];
  enableDownloadForAttachment: boolean = false;
  selectedVendorUser: any;
  attachmentSource: string = 'calendarEvent';
  assestBaseUrl: string = environment.assestsBasePath;
  selectedChannelForEvent: any;
  @Input() eventFromModule: boolean;
  //channel
  channelsN: ChannelN[] = [];
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();



  constructor(private app: AppMainComponent,
    private appMainService: AppMainService,
    private objectEventService: ObjectCalendarEventService,
    private calendarEventService: CalendarEventService,
    private locationService: LocationService,
    private accountService: AccountService,
    private leadService: LeadService,
    private opportunityService: OpportunityService,
    private messageService: MessageService,
    private configService: ConfigurationService,
    private columnSettingsService: SharedColumnSettingsService,
    private channelService: SharedChannelService,
    private activityService: ActivityService,
  ) { }

  ngOnInit(): void {
    this.configService.getModulesForQuestionnaire().subscribe(modules => {
      this.taskModules = modules.filter(nm => nm.id == 1 || nm.id == 2 || nm.id == 3);
    });
    this.selectedVendorUser = this.usersInCalendar?.[0]||null;
    this.objectEventService.getAllTimeZones().then(resp => { this.timezones = resp });
    this.selectedCustomRepeat = this.repeatCustom[0];
    this.selectedEnd = "End by";
    this.minimumDate = new Date();
    this.monthNames = getLocaleMonthNames('en-US', FormStyle.Format, TranslationWidth.Wide);
    let monthNames = this.monthNames.map((elem, index) => { return { label: elem, value: index + 1 } });
    this.monthNames = monthNames;
    this.allUsersList = [...this.app.usersList];

    for (let i = 1; i <= 31; i++) {
      this.days.push({ label: i, value: i });
    }

    this.loadLocationAndRepeatTypes();
    this.setModuleDetails();

  }
  async loadLocationAndRepeatTypes() {
    this.locations = await this.getLocations();
    this.repeats = this.app.eventRepeatType;
    this.checkEventMode();

    this._renderAccounts();
    this._renderLeads();
    this._renderOpportunities();

  }

  checkEventMode() {
    this.requiredCalendarEventAttendees = [];
    this.optionalCalendarEventAttendees = [];
    // this.locations = await this.getLocations();
    // this.repeats = await this.getRepeatTypes();
    if (this.mode === "edit" && this.event) {
      this.enableDownloadForAttachment = true;
      this.showEvent();
    } else {
      this.enableDownloadForAttachment = false;
      this.eventTemp.calendarEvent.name = '';
      this.eventTemp.calendarEvent.description = '';
      this.requiredCalendarEventAttendees = [];
      this.optionalCalendarEventAttendees = [];
      if (this.source === 'calendar'){
        const startDate = new Date(this.dateSelectionForCalendar.getTime() + 0 * 60000);
        this.startDate = startDate;
        //this.startDate = this.app._showDateTimeWithZone(startTime);
        const endDate = new Date(this.dateSelectionForCalendar.getTime() + 30 * 60000);
        this.endDate = endDate;
        //this.endDate = this.app._showDateTimeWithZone(endDate);
        this.startTime = this.getTimeSlot(new Date(this.startDate), 0);
        this.endTime = this.getTimeSlot(new Date(this.endDate), 0);
      }
      else {
        const startDate = new Date(new Date().getTime() + 15 * 60000);
        this.startDate = this.app._showDateTimeWithZone(startDate);
        const endDate = new Date(new Date().getTime() + 45 * 60000);
        this.endDate = this.app._showDateTimeWithZone(endDate);
        this.startTime = this.getTimeSlot(new Date(this.startDate), 0);
        this.endTime = this.getTimeSlot(new Date(this.endDate), 0);
      }


      // this.startDate = this.getTimeSlot(new Date(), 15);
      // this.endDate = this.getTimeSlot(this.getTimeSlot(new Date(), 15), 30);
      this.selectedRepeat = this.repeats[0];
      if (this.locations && this.locations[0]) {
        this.selectedLocation = this.locations[0];
      }
      this.changeMessage(this.selectedRepeat?.name);
    }
  }

  cancel(isComple = false) {
    this.eventTemp.calendarEvent.description = '';
    this.eventTemp.calendarEvent.location = '';
    this.source = '';
    this.isShown = false;
    this.showValidation = false;
    this.createEvent?.reset();
    this.displayAddEvent = false;
    this.selectedRepeat = null;
    this.selectedWeekDays = [];
    this.selectedReminder = { name: 'Select Repeat', value: 0 };
    this.requiredCalendarEventAttendees = [];;
    this.optionalCalendarEventAttendees = [];
    this.usersList = [...this.allUsersList];
    // commented below line as it setting id field to 0 of this.app.usersList, which removing username from activity list
    // this.usersList.forEach(el=>{el.id=0});
    this.eventTemp = {
      "id": 0,
      "createdSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "createdDate": new Date(),
      "objectId": null,
      "objectTypeId": null,
      "calendarEventId": 0,
      "channelId": null,
      "calendarEvent": {
        "id": 0,
        "createdSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "createdDate": new Date(),
        "name": "",
        "description": "",
        "organizationId": this.app.user.organizationId,
        "startDate": null,
        "endDate": null,
        "locationId": 0,
        "location": "",
        "userId": 0,
        "colorCodeId": null,
        "seriesId": "",
        "syncDate": new Date(),
        "reminderInMinutes": 0,
        "isAllDay": true,
        "repeatTypeId": null,
        "isRecurring": true,
        "isOnlineMeeting": false,
        "statusId": Status.Active,
        "typeId": null,
        "groupId": null,
        "isValid": true,
        "validFromDate": null,
        "validToDate": null,
        "calendarEventAttendees": [],
        "eventColorCode": '',
        "occurrences": [
          {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": 0,
            "dayOfWeek": null,
            "weekOfMonth": null,
            "dayOfMonth": null,
            "monthOfYear": null,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
        ],
        "eventAttachments": [
          {
            "id": 0,
            "name": '',
            "contentType": '',
            "contentBytes": '',
            "downloadLink": '',
            "extension": '',
            "vendorAttachementId": ''
          }
        ],
        "vendorUserId": 0,
        "recurrence": null,
      }
    }
    this.event = null;
    this.storedCalendarAttendees = [];
    if (isComple) {
      this.completeEvent.emit({ cancelEvent: this.displayAddEvent });
    } else {
      this.cancelEvent.emit({ cancelEvent: this.displayAddEvent });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // for (let property in changes) {
    //   if (property === 'displayAddEvent' || property === "mode") { this.checkEventMode(); }
    // }

    if (changes?.selectedChannel?.currentValue) {
        this.selectedChannel = changes.selectedChannel.currentValue;
        this.eventTemp.channelId = this.selectedChannel?.id||this.eventTemp.channelId;
        this.selectedChannelForEvent = {id: this.selectedChannel?.id};
    }
    if (changes?.eventFromModule?.currentValue) {
      this.eventFromModule = changes.eventFromModule.currentValue;
  }

    if (changes?.objectId?.currentValue) {
      this.objectId = changes.objectId.currentValue;
    }

    if (changes?.objectTypeId?.currentValue) {
        this.eventTemp.objectTypeId = changes.objectTypeId.currentValue;
        this.setAssociationName(this.eventTemp.objectTypeId);
    }

    if (changes?.selectedObject?.currentValue) {
        const obj = changes.selectedObject.currentValue;
        if(obj) {
            this.eventTemp.objectId = {
                "id": obj.id,
                "businessName": obj.businessName ? obj.businessName : obj.name,
                "name": obj.businessName ? obj.businessName : obj.name,
            }
        }
    }

    if (changes?.event?.currentValue) {
      this.eventTemp.calendarEvent = changes.event.currentValue;
      this.requiredCalendarEventAttendees = this.eventTemp.calendarEvent.calendarEventAttendees;
      this.startDate = this.eventTemp.calendarEvent.startDate;
      this.endDate = this.eventTemp.calendarEvent.endDate;
      this.showEvent();
    }

    if (changes?.mode?.currentValue) {
      if (changes.mode.currentValue === 'add') {
        this.headerTitle = 'Add Event';
      } else if (changes.mode.currentValue === 'edit') {
        this.headerTitle = 'Edit Event';
      }
    }

    if (changes?.isViewMode?.currentValue) {
      this.isViewMode = changes.isViewMode.currentValue;
      this.headerTitle = this.isViewMode ? 'View Event' : this.headerTitle;
    }
    if (changes?.dateSelectionForCalendar?.currentValue) {
      this.dateSelectionForCalendar = changes.dateSelectionForCalendar.currentValue;
    }
  }

  async _renderAccounts() {
    let data = {channelId: this.selectedChannel?.id||0};
    let accountsData = await this.accountService.getAllAccounts(data);
    this.allAccountsName = accountsData;
    this.getAssociationNames(this.eventTemp.objectTypeId);
  }

  _renderLeads() {
    this.leadService.getAllLeadsNameListByTerritory(0,this.app.user.organizationId, this.app.user.userId, false, '')
      .subscribe((res) => {
        this.allLeadName = res;
        this.getAssociationNames(this.eventTemp.objectTypeId);
      });
  }

  _renderOpportunities() {
    this.opportunityService.getAllOpportunitiesNameList(this.app.user.organizationId, this.app.user.userId, '',this.selectedChannel?.id)
      .subscribe((res) => {
        if(res && res.length){
          this.allOpportunityName = res.map(item => ({id: item.id, businessName: item.name}));
          this.getAssociationNames(this.eventTemp.objectTypeId);
        }
      });
  }

  getattendees(data, isreq) {
    const rec = data.filter(el => el.statusId == 1 && el.isRequired == isreq);
    return rec
  }

  showEvent() {
    let eventData: any = this.app.copyObjectWithoutRefrence(this.event);
    this.selectedtimeZone = this.timezones?.find(x => x.id == eventData?.timeZoneId);
    this.allUsersList = [...this.app.usersList];
    this.usersList = [...this.allUsersList];
    this.selectedVendorUser = this.usersInCalendar.find((obj) => obj?.id == eventData?.vendorUserId) || eventData?.vendorUserId;
    this.selectedVendorUser = this.selectedVendorUser||this.usersInCalendar?.[0]||null;
    // commented below line as it setting id field to 0 of this.app.usersList, which removing username from activity list
    // this.usersList.forEach(el=>{el.id=0});
    this.eventAttachments = [];
    if(eventData?.eventAttachments  && eventData?.eventAttachments.length > 0){
      this.eventAttachments = this.processAttachmentForEditDataBinding(eventData?.eventAttachments);
    }
    this.startDate = this.app._showDateTimeWithZone(eventData.startDate); //this.app.getTimezoneDate(eventData.startDate); //new Date(eventData.startDate + 'Z');
    this.endDate = this.app._showDateTimeWithZone(eventData.endDate); //this.app.getTimezoneDate(eventData.endDate); //new Date(eventData.endDate + 'Z');
    this.startTime = this.getTimeSlot(new Date(this.startDate), 0);
    this.endTime = this.getTimeSlot(new Date(this.endDate), 0);
    this.minimumDate =this.app._showDateTimeWithZone(eventData.startDate);
    this.allDay = eventData.isAllDay;
    this.selectedReminder = this.reminders.filter(elem => elem.value === eventData.reminderInMinutes)[0];
    this.selectedRepeat = this.repeats.filter(elem => elem.id === eventData.repeatTypeId)[0];
    this.storedCalendarAttendees = eventData.calendarEventAttendees;
    const requiredCalendarEventAttendees = eventData.calendarEventAttendees && eventData.calendarEventAttendees.length > 0 ? this.getattendees(eventData.calendarEventAttendees, true) : [];
    this.usersList = [
      ...this.usersList,
      ... requiredCalendarEventAttendees.map(( {id, emailAddress, name, ...rest}) => ({ ...rest, emailId: emailAddress, id: id, name: name}))
    ].map(({id, emailId, name}) => ({id, emailId, name}));
    this.requiredCalendarEventAttendees = [];
    requiredCalendarEventAttendees.forEach(element => {
      //element.emailAddress = element.emailAddress.toLowerCase();
      const temp = this.usersList.find(el => el.emailId == element.emailAddress);
      this.requiredCalendarEventAttendees.push({...element,...temp});
    });
    const optionalCalendarEventAttendees = eventData.calendarEventAttendees && eventData.calendarEventAttendees.length > 0 ? this.getattendees(eventData.calendarEventAttendees, false) : [];
    this.usersList = [
      ...this.usersList,
      ... optionalCalendarEventAttendees.map(( {id, emailAddress, name, ...rest}) => ({ ...rest, emailId: emailAddress, id: id, name: name}))
    ].map(({id, emailId, name}) => ({id, emailId, name}));
    this.optionalCalendarEventAttendees = []
    optionalCalendarEventAttendees.forEach(element => {
      //element.emailAddress = element.emailAddress.toLowerCase();
      const temp = this.usersList.find(el => el.emailId == element.emailAddress);
      this.optionalCalendarEventAttendees.push({...element,...temp});
    });
    if (this.optionalCalendarEventAttendees.length > 0) { this.isShown = true; }
    this.usersList = [...this.allUsersList];
    // this.selectedLocation = this.locations.filter(elem => elem.id === eventData.locationId)[0];
    this.selectedWeekDays = [];
    if(eventData.repeatType?.name){
      if (eventData.repeatType.name === "Weekly") {
        if ((eventData.occurrences && eventData.occurrences.length > 1)) {
          eventData.occurrences.forEach(elem => {
            this.selectedWeekDays.push(this.weekDays.filter(day => day.value === elem.dayOfWeek)[0]);
          });
        } else if (eventData.repeatType.name === "Weekly" && (eventData.occurrences && eventData.occurrences.length === 1)) {
          this.weekDays.map(elem => elem).filter(day => day.value === eventData.occurrences[0].dayOfWeek)[0].checked = true;
        }
      } else if (eventData.repeatType.name === "Yearly") {
        this.selectedYearlyMonth = this.monthNames.filter(elem => elem.value === eventData.occurrences[0].monthOfYear)[0];
        this.selectedYearlyDay = this.days.filter(elem => elem.value === eventData.occurrences[0].dayOfMonth)[0];
      } else if (eventData.repeatType.name === "Monthly") {
        this.selectedMonthlyDay = this.days.filter(elem => elem.value === eventData.occurrences[0].dayOfMonth)[0];
      }
    }

    this.changeMessage(this.endDate);

    this.eventTemp.calendarEvent = this.app.copyObjectWithoutRefrence(eventData);
  }

  async getLocations() {
    let locs: Location[] = []
    await this.locationService.lionO36020APILocationGetAllLocationGet(this.app.user.organizationId).toPromise().then((res: Location[]) => {
      locs = res;
    })
    return locs;
  }

  async getRepeatTypes() {

    return this.app.eventRepeatType;
  }

  changeEndDate(val) {
    this.endDate = this.getTimeSlot(val, 30);
    this.changeMessage(this.selectedRepeat?.name);
  }

  changeEndTime(val){
    this.endTime = this.getTimeSlot(val, 0);
    this.changeMessage(this.selectedRepeat?.name);
  }

  uploadAttachments(files: File[], fileUpload: FileUpload) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      let count = this.eventAttachments.length;
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.app.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
          }
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            const lastIndex = name.lastIndexOf(".");
            const fileName = name.substring(0, lastIndex);

            const attachment = {
              id: 0,
              name: `${fileName}.${extension}`,
              contentType: '',
              contentBytes: content,
              downloadLink: '',
              extension,
              vendorAttachementId: '',
              statusId: Status.Active,
            };
            /** There are some extra things need to be added for using the shared component */
            if (count >= this.eventAttachments.length) {
                this.eventAttachments.push({ attachment });
            } else {
                this.eventAttachments[count].attachment = { ...attachment };
            }
            count++;
            if (count === this.eventAttachments.length) {
              fileUpload.clear();
            }
          });
        }

      }
      this.files = [];
      this.appMainService.isHideSpinner('upload');
    } else {
      this.appMainService.isHideSpinner('upload');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
  }

  removeAttachment(attachments){
    this.eventAttachments = attachments.filter(obj => obj?.attachment?.statusId != Status.Deleted);
  }

  getTimeSlot(date, timeSlot) {
    const start = moment(date.toISOString());
    const remainder = timeSlot - (start.minute() % timeSlot);
    const dateTime = moment(start).add(remainder, "minutes").format("MM/DD/YYYY, hh:mm:ss A");
    return new Date(dateTime);
  }

  changeMessage(repeatType) {
    let startDateTime = this.startDate;
    let endDateTime = this.endDate;
    if(this.allDay){
      this.startTime = new Date(this.startDate.toLocaleDateString() + " " + "8:00:00 AM");
      this.endTime =new Date(this.endDate.toLocaleDateString() + " " + "5:00:00 PM");
    }
    // else {
    //   this.startTime = this.getTimeSlot(new Date(this.startDate), 0);
    //   this.endTime = this.getTimeSlot(new Date(this.endDate), 0);
    // }

    let startDate = startDateTime.toLocaleDateString();
    //let startTime = startDateTime.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    let startTime = this.startTime?.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    let endDate = endDateTime.toLocaleDateString();
    //let endTime = endDateTime.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    let endTime = this.endTime?.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });

    let html = ``;
    this.showMessage = true;
    if (repeatType === "Weekly") {
      let weekDay = this.getWeekDaysList();
      if (weekDay.length > 0) {
        if(this.allDay == true){
          html = `This event occurs every ${weekDay.substring(0, weekDay.length - 2)} effective from ${startDate} to ${endDate}`;
        } else if(this.allDay == false) {
          html = `This event occurs every ${weekDay.substring(0, weekDay.length - 2)} effective from ${startDate}
                    until ${endDate} from ${startTime} to ${endTime}`;
        }
      } else {
        html = ``;
      }
    } else if (repeatType === "Never" || repeatType === "Daily") {
      if(this.allDay == true){
        html = `This event will take place from ${startDate} to ${endDate}`;
      } else if(this.allDay == false) {
        html = `This event will take place on ${startDate} from ${startTime} to ${endDate} till ${endTime}`;
      }
    } else if (repeatType === "Monthly") {
      let day = this.selectedMonthlyDay.value;
      html = `This event occurs every month on day ${day} starting from ${startDate}`;
    } else if (repeatType === "Yearly") {
      let day = this.selectedYearlyDay.value;
      let month = this.selectedYearlyMonth.label;
      html = `This event occurs every year on day ${day} of ${month} starting ${startDate}`;
    }

    if (html === "") {
      this.showMessage = false;
    } else {
      this.evtMsg = html;
    }
  }

  getDayOfWeek(date) {
    const dayOfWeek = new Date(date).getDay();
    const weekDays = this.weekDays.map(elem => elem.name);
    return isNaN(dayOfWeek) ? null :
      weekDays[dayOfWeek];
  }

  getWeekDaysList() {
    let weekDays = this.weekDays.map(elem => elem.name);
    let weekDay = '';
    for (var i = 0; i < this.weekDays.length; i++) {
      if (this.weekDays[i].checked) {
        if (this.weekDays[i].value !== 0) {
          weekDay += weekDays[this.weekDays[i].value - 1] + ", ";
        } else {
          weekDay += weekDays[6] + ", ";
        }
      } else {
        weekDay.substring(weekDay.lastIndexOf(weekDays[this.weekDays[i].value - 1]) + 1);
      }
    }
    return weekDay;
  }

  changeRepeatType(val) {
    if(val){
      this.startTime = new Date(this.startDate.toLocaleDateString() + " " + "8:00:00 AM");
      this.endTime =new Date(this.endDate.toLocaleDateString() + " " + "5:00:00 PM");
      this.disableTime = true;
    } else {
      this.startTime = this.getTimeSlot(new Date(this.startDate), 0);
      this.endTime = this.getTimeSlot(new Date(this.endDate), 0);
      this.disableTime = false;
    }
    this.selectedRepeat = this.repeats[0];
    let endDateTime = this.endDate;
    this.allDay = val;
    // if (val) {
    //   this.endDate = new Date(endDateTime.toLocaleDateString() + " " + "11:59:00 PM");
    // } else {
    //   this.startDate = this.getTimeSlot(new Date(this.startDate), 0);
    //   this.endDate = this.getTimeSlot(new Date(this.endDate), 0);
    // }
    this.changeMessage(this.selectedRepeat?.name);
  }

  changeAllDay() {

  }

  checkForm() {
    let showerror = false;
    if (
      !this.startDate || !this.endDate
    ) {
      showerror = true;
    }

    if (showerror) {
      return showerror;
    }
    return showerror;
  }

  combineDateAndTime(startDate, startTime): Date{
    const utcMomentForDate = moment.utc(startDate);
    const utcMomentForTime = moment.utc(startTime);
    const timeOnly = new Date(0, 0 , 0, utcMomentForTime.hour(), utcMomentForTime.minute(), utcMomentForTime.second());
    const dateOnly = utcMomentForDate.startOf('day').toDate();
    const combinedMoment = moment(startDate).set({
      hour: timeOnly.getHours(),
      minute: timeOnly.getMinutes(),
      second: timeOnly.getSeconds()
    });
    const combinedDateAndTime: Date = combinedMoment.utc().toDate();
    return combinedDateAndTime;
  }

  combineDates(date1: Date, date2: Date): Date {
    // Extract date components from the first date
    const year = date1.getFullYear();
    const month = date1.getMonth();
    const day = date1.getDate();

    // Extract time components from the second date
    const hours = date2.getHours();
    const minutes = date2.getMinutes();
    const seconds = date2.getSeconds();
    const milliseconds = date2.getMilliseconds();

    // Create a new Date combining date1's date and date2's time
    const combinedDate = new Date(year, month, day, hours, minutes, seconds, milliseconds);

    return combinedDate;
  }

  //#region SaveEvent
  save() {
    if (this.createEvent.form.valid) {
      this.startDate = this.combineDates(this.startDate, this.startTime);
      this.endDate = this.combineDates(this.endDate, this.endTime);
      if (this.checkForm()) {
        this.showValidation = true;
      } else {
        this.showValidation = false;
        this.disableSubmitButton = true;
        if (this.mode !== "edit") {
          this.eventTemp.objectId = this.eventTemp.objectId?.id||this.eventTemp.objectId||0;
          this.eventTemp.objectTypeId = this.eventTemp.objectTypeId || 0;

          this.appMainService.isShowSpinner('addEvent');
          this.eventTemp.calendarEvent = this.getCalendarEventObjectValues(this.eventTemp.calendarEvent);
          this.objectEventService.lionO36020APIObjectCalendarEventPost(this.eventTemp).subscribe(res => {
            this.appMainService.isHideSpinner('addEvent');
            this.disableSubmitButton = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Event saved successfully...' });
            this.cancel(true);
            this.onCompletedSaveEvent.emit();
            //this.app.getAllObjects();
          },
            err => {
              this.appMainService.isHideSpinner('addEvent');
              this.disableSubmitButton = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: JSON.stringify(err.error.errors) });
            });
        } else {
          this.eventTemp.calendarEvent = this.getCalendarEventObjectValues(this.eventTemp.calendarEvent);
          this.storedCalendarAttendees?.forEach(el => {
            if (!this.eventTemp.calendarEvent.calendarEventAttendees.some(atnd => atnd.emailAddress == el.emailAddress)) {
              el.statusId = 3;
              this.eventTemp.calendarEvent.calendarEventAttendees.push(el);
            } else {
              const attendee = this.eventTemp.calendarEvent.calendarEventAttendees.find(atnd => atnd.emailAddress == el.emailAddress);
              attendee.id = el.id;
            }

          });
          this.eventTemp.calendarEvent['vendorUserId'] = this.selectedVendorUser?.id;
          this.updateEvent(this.eventTemp.calendarEvent);
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill out event title...' });
    }
  }

  updateEvent(updatedEvent: any) {
    this.appMainService.isShowSpinner('editEvent');
    this.activityService.updateEvents (updatedEvent).subscribe(res => {
      this.appMainService.isHideSpinner('editEvent');
      this.disableSubmitButton = false;
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Event updated successfully...' });
      this.cancel(true);
      this.onCompletedSaveEvent.emit();
    },  err => {
      this.appMainService.isHideSpinner('editEvent');
      this.disableSubmitButton = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: JSON.stringify(err.error.errors) });
    });
  }

  getCalendarEventObjectValues(calendarEvent?: CalendarEvent) {
    calendarEvent.vendorUserId = this.selectedVendorUser?.id;
    calendarEvent.eventAttachments = this.processAttachmentForAddEvent(this.eventAttachments);
    calendarEvent.endDate = this.app._saveDateTimeWithZone(this.endDate);
    calendarEvent.startDate = this.app._saveDateTimeWithZone(this.startDate);
    calendarEvent.timeZoneId = this.selectedtimeZone ? this.selectedtimeZone.id : null;
    //calendarEvent.eventColorCode = this.color;
    const addedAttendees = [];
    this.requiredCalendarEventAttendees.forEach(element => {
      const idExist = this.eventTemp.calendarEvent.calendarEventAttendees.find(prev=> prev.emailAddress==element?.emailId);
      const temp = {
        "id": this.mode == 'edit' ? (idExist?.id||0) : 0,
        "createdSource": element.createdSource,
        "updatedSource": element.updatedSource,
        "createdBy": element.createdBy,
        "updatedBy": element.updatedBy,
        "createdDate": element.createdDate,
        "updatedDate": element.updatedDate,
        "calendarEventId": this.eventTemp.calendarEvent?.id,
        "emailAddress": element.emailId,
        "name": element?.name,
        "isRequired": true,
        "statusId": Status.Active
      }
      addedAttendees.push(temp);
    });
    this.eventTemp.calendarEvent.calendarEventAttendees = addedAttendees;
    this.optionalCalendarEventAttendees.forEach(element => {
      const temp = {
        "id": this.mode == 'edit' ? element.id : 0,
        "createdSource": element.createdSource,
        "updatedSource": element.updatedSource,
        "createdBy": element.createdBy,
        "updatedBy": element.updatedBy,
        "createdDate": element.createdDate,
        "updatedDate": element.updatedDate,
        "calendarEventId": this.eventTemp.calendarEvent.id,
        "emailAddress": element.emailId,
        "name": element.name,
        "isRequired": false,
        "statusId": Status.Active
      }
      this.eventTemp.calendarEvent.calendarEventAttendees.push(temp);
    });
    let occurrenceCheck = calendarEvent.occurrences ? calendarEvent.occurrences.findIndex(elem => elem.id === 0) : -1;
    if (occurrenceCheck == -1) {
      calendarEvent.occurrences = [];
      if (this.selectedRepeat.name === "Weekly") {
        let selectedWeeks = this.weekDays.filter(elem => elem.checked);
        for (let week of selectedWeeks) {
          let obj = {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": calendarEvent.id,
            "dayOfWeek": week.value,
            "weekOfMonth": null,
            "dayOfMonth": null,
            "monthOfYear": null,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
          calendarEvent.occurrences.push(obj);
        }
      } else if (this.selectedRepeat.name === "Monthly") {
        let obj = {
          "id": 0,
          "createdSource": this.app.userIP,
          "createdBy": this.app.user.userId,
          "createdDate": new Date(),
          "calendarEventId": 0,
          "dayOfWeek": null,
          "weekOfMonth": null,
          "dayOfMonth": this.selectedMonthlyDay.value,
          "monthOfYear": null,
          "maxNoOfOccurrence": null,
          "seperationCount": null,
          "statusId": Status.Active,
          "typeId": null,
          "groupId": null,
          "isValid": true,
          "validFromDate": null,
          "validToDate": null
        }
        calendarEvent.occurrences.push(obj);
      } else if (this.selectedRepeat.name === "Yearly") {
        let obj = {
          "id": 0,
          "createdSource": this.app.userIP,
          "createdBy": this.app.user.userId,
          "createdDate": new Date(),
          "calendarEventId": 0,
          "dayOfWeek": null,
          "weekOfMonth": null,
          "dayOfMonth": this.selectedYearlyDay.value,
          "monthOfYear": this.selectedYearlyMonth.value,
          "maxNoOfOccurrence": null,
          "seperationCount": null,
          "statusId": Status.Active,
          "typeId": null,
          "groupId": null,
          "isValid": true,
          "validFromDate": null,
          "validToDate": null
        }
        calendarEvent.occurrences.push(obj);
      } else {
        calendarEvent.occurrences = null;
      }
    } else {
      if (calendarEvent.repeatTypeId !== this.selectedRepeat.id) {
        //calendarEvent.occurrences = [];
        if (this.selectedRepeat.name === "Weekly") {
          let selectedWeeks = this.weekDays.filter(elem => elem.checked);
          for (let week of selectedWeeks) {
            let obj = {
              "id": calendarEvent.occurrences[0].id,
              "createdSource": this.app.userIP,
              "createdBy": this.app.user.userId,
              "createdDate": new Date(),
              "calendarEventId": calendarEvent.id,
              "dayOfWeek": week.value,
              "weekOfMonth": null,
              "dayOfMonth": null,
              "monthOfYear": null,
              "maxNoOfOccurrence": null,
              "seperationCount": null,
              "statusId": Status.Active,
              "typeId": null,
              "groupId": null,
              "isValid": true,
              "validFromDate": null,
              "validToDate": null
            }
            calendarEvent.occurrences.push(obj);
          }
        } else if (this.selectedRepeat.name === "Monthly") {
          let obj = {
            "id": calendarEvent.occurrences[0].id,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": 0,
            "dayOfWeek": null,
            "weekOfMonth": null,
            "dayOfMonth": this.selectedMonthlyDay.value,
            "monthOfYear": null,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
          calendarEvent.occurrences.push(obj);
        } else if (this.selectedRepeat.name === "Yearly") {
          let obj = {
            "id": calendarEvent.occurrences[0].id,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": 0,
            "dayOfWeek": null,
            "weekOfMonth": null,
            "dayOfMonth": this.selectedYearlyDay.value,
            "monthOfYear": this.selectedYearlyMonth.value,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
          calendarEvent.occurrences.push(obj);
        } else {
          calendarEvent.occurrences = null;
        }
      } else {
        if (this.selectedRepeat.name === "Weekly") {
          let selectedWeeks = this.weekDays.filter(elem => elem.checked);
          let occurrenceWeekDays = calendarEvent.occurrences.map(elem => elem.dayOfWeek);
          for (let week of selectedWeeks) {
            if (!occurrenceWeekDays.includes(week.value)) {
              let obj = {
                "id": 0,
                "createdSource": this.app.userIP,
                "createdBy": this.app.user.userId,
                "createdDate": new Date(),
                "calendarEventId": calendarEvent.id,
                "dayOfWeek": week.value,
                "weekOfMonth": null,
                "dayOfMonth": null,
                "monthOfYear": null,
                "maxNoOfOccurrence": null,
                "seperationCount": null,
                "statusId": Status.Active,
                "typeId": null,
                "groupId": null,
                "isValid": true,
                "validFromDate": null,
                "validToDate": null
              }
              calendarEvent.occurrences.push(obj);
            }
          }
        } else if (this.selectedRepeat.name === "Monthly") {
          let obj = {
            "id": calendarEvent.occurrences[0].id,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": 0,
            "dayOfWeek": null,
            "weekOfMonth": null,
            "dayOfMonth": this.selectedMonthlyDay.value,
            "monthOfYear": null,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
          calendarEvent.occurrences.push(obj);
        } else if (this.selectedRepeat.name === "Yearly") {
          //calendarEvent.occurrences = [];
          let obj = {
            "id": calendarEvent.occurrences[0].id,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "calendarEventId": 0,
            "dayOfWeek": null,
            "weekOfMonth": null,
            "dayOfMonth": this.selectedYearlyDay.value,
            "monthOfYear": this.selectedYearlyMonth.value,
            "maxNoOfOccurrence": null,
            "seperationCount": null,
            "statusId": Status.Active,
            "typeId": null,
            "groupId": null,
            "isValid": true,
            "validFromDate": null,
            "validToDate": null
          }
          calendarEvent.occurrences.push(obj);
        } else {
          calendarEvent.occurrences = null;
        }
      }
    }

    calendarEvent.organizationId = this.app.user.organizationId;
    calendarEvent.reminderInMinutes = this.selectedReminder.value;
    calendarEvent.isAllDay = this.allDay;
    calendarEvent.repeatTypeId = this.selectedRepeat ? this.selectedRepeat.id : null;
    calendarEvent.name = calendarEvent.name;
    calendarEvent.userId = this.app.user.userId;
    calendarEvent.locationId = null;//this.selectedLocation?.id;
    if (this.mode === "edit") {
      calendarEvent.updatedBy = this.app.user.userId;
      calendarEvent.updatedSource = this.app.userIP;
      calendarEvent.updatedDate = new Date();
    }
    return calendarEvent;
  }

  processAttachmentForAddEvent(data){
    return data.map((obj) => {
      const { id, name, contentType, contentBytes, downloadLink, extension, vendorAttachementId } = obj.attachment;
      return { id, name, contentType, contentBytes, downloadLink, extension, vendorAttachementId };
    })
  }

  processAttachmentForEditDataBinding(data){
    return data.map((obj) => {
      const { id, name, contentType, contentBytes, downloadLink, extension, vendorAttachementId } = obj;
      return {
        attachment: {
          id: id,
          name,
          contentType,
          content: contentBytes,
          location: downloadLink,
          extension,
          vendorAttachementId,
          statusId: Status.Active
        },
      };
    });
  }

    searchAssociations(query) {
        if (this.eventTemp.objectTypeId) {
        switch (this.eventTemp.objectTypeId) {
            case 1:
                this.searchLeads(query);
                break;
            case 2:
                this.searchAccount(query);
                break;
            case 3:
                this.searchOpportunity(query);
                break;
            }
        }
    }

    searchAccount(event) {
        let data = {
            currentPage: 0,
            pageSize: 0,
            organizationId: this.app.user.organizationId,
            loginUserId: this.app.user.userId,
            search: event.query,
            channelId: this.selectedChannel?.id||0
        }
        this.accountService.getAllAccounts(data).then(accounts => {
            this.allAccountsName = accounts;
            this.getAssociationNames(this.eventTemp.objectTypeId);
        });
    }

    searchLeads(event){
        this.leadService.getAllLeadsNameListByTerritory(0,this.app.user.organizationId, this.app.user.userId, false, event.query)
        .subscribe((res) => {
          this.allLeadName = res;
          this.getAssociationNames(this.eventTemp.objectTypeId);
        });
    }

    searchOpportunity(event){
        this.opportunityService.getAllOpportunitiesNameList(this.app.user.organizationId, this.app.user.userId, event.query, this.selectedChannel?.id)
        .subscribe((res) => {
          if(res && res.length){
            this.allOpportunityName = res.map(item => ({id: item.id, businessName: item.name}));
            this.getAssociationNames(this.eventTemp.objectTypeId);
          }
        });
    }

    getAssociationNames(value) {
        if (value > 0) {
          this.associationNames = [];
          this.objectTypeId = value;
          // this.tempTask.objectId = 0;
          this.setAssociationName(value);
        }
    }

    setAssociationName(value) {
        if (value && value > 0) {
          switch (value) {
            case 1:
              this.allAssociationNamesList = this.allLeadName;
              this.associationNames = this.allLeadName;
              break;
            case 2:
              this.allAssociationNamesList = this.allAccountsName;
              this.associationNames = this.allAccountsName;
              break;
            case 3:
              this.allAssociationNamesList = this.allOpportunityName;
              this.associationNames = this.allOpportunityName;
              break;
          }

          if (this.objectId > 0) {
            let selectedItem = this.allAssociationNamesList.find(x => x.id == this.objectId);
            selectedItem &&
              (this.eventTemp.objectId = selectedItem);
          }
        }
    }

  search(query) {
    const filtered: any[] = this.allUsersList.filter(l=> (l.name.toLowerCase().indexOf(query.toLowerCase()) == 0) || (l.emailId.toLowerCase().indexOf(query.toLowerCase()) == 0));

    if(filtered?.length==0 && checkValidEmail(query)){
        filtered.push({
            id: query,
            emailId: query.toLowerCase(),
            name: query.toLowerCase()
        });
    }

    this.usersList = [...filtered];
  }
  showOptional() {
    this.isShown = !this.isShown;
  }
  showCustom() {
    this.resetCustomRecurring();
    if (this.eventTemp.calendarEvent.recurrence) {
      this.tempReccurringEvent = this.eventTemp.calendarEvent.recurrence;
    }
    if (this.tempReccurringEvent.repeatTypeId == 120) {
      if (!this.tempReccurringEvent.daysOfWeek) {
        this.selectedCustomRepeat = this.repeats.find(el => el.name == 'Daily');
        this.selectedDay = "Every day";
        this.selectedDayNumber = this.dayNumbers.find(el => el.value == this.tempReccurringEvent.interval);
      } else if (this.tempReccurringEvent.daysOfWeek) {
        this.selectedCustomRepeat = this.repeats.find(el => el.name == 'Daily');
        this.selectedDay = "Every weekday";
      }
    } else if (this.tempReccurringEvent.repeatTypeId == 121) {
      this.selectedCustomRepeat = this.repeats.find(el => el.name == 'Weekly');
      this.selectedWeekNumber = this.weekNumbers.find(el => el.value == this.tempReccurringEvent.interval);
      let weekdaysSplit = this.tempReccurringEvent.daysOfWeek.split(", ");
      this.weekDays.forEach(elem => {
        if (weekdaysSplit.some(el => el == elem.name)) { elem.checked = true; }
      });
    } else if (this.tempReccurringEvent.repeatTypeId == 122) {
      this.selectedCustomRepeat = this.repeats.find(el => el.name == 'Monthly');
      if (this.tempReccurringEvent.dayOfMonth && this.tempReccurringEvent.monthOfYear) {
        this.selectedMonth = 'Day';
        this.monthDay1 = this.tempReccurringEvent.dayOfMonth;
        this.monthDay2 = this.tempReccurringEvent.monthOfYear;
      } else if (this.tempReccurringEvent.index && this.tempReccurringEvent.daysOfWeek && this.tempReccurringEvent.monthOfYear) {
        this.selectedMonth = 'The';
        this.selectedMonthWeek = this.monthWeeks.find(el => el.value == this.tempReccurringEvent.index);
        this.selectedWeek = this.weekDays.find(el => el.name == this.tempReccurringEvent.daysOfWeek);
        this.monthDay1 = this.tempReccurringEvent.monthOfYear;
      }
    } else if (this.tempReccurringEvent.repeatTypeId == 123) {
      this.selectedCustomRepeat = this.repeats.find(el => el.name == 'Yearly');
      this.selectedYearNumber = this.yearNumbers.find(el => el.value == this.tempReccurringEvent.interval);
      if (this.tempReccurringEvent.monthOfYear && this.tempReccurringEvent.dayOfMonth) {
        this.selectedYear = 'On'
        this.selectedYearMonth = this.monthNames.find(el => el.value == this.tempReccurringEvent.monthOfYear);
        this.yearDay = this.tempReccurringEvent.dayOfMonth;
      } else if (this.tempReccurringEvent.index && this.tempReccurringEvent.daysOfWeek && this.tempReccurringEvent.monthOfYear) {
        this.selectedYear = 'On the'
        this.selectedYearCount = this.monthWeeks.find(el => el.value == this.tempReccurringEvent.index);
        this.selectedYearWeek = this.weekDays.find(el => el.name == this.tempReccurringEvent.daysOfWeek);
        this.selectedYearMonth2 = this.monthNames.find(el => el.value == this.tempReccurringEvent.monthOfYear);
      }
    } else {
      this.tempReccurringEvent.repeatTypeId = 119;
      this.selectedCustomRepeat = this.repeats.find(el => el.id == this.tempReccurringEvent.repeatTypeId);
    }
    this.tempReccurringEvent.calenderEventStartDate = new Date(this.startDate);
    this.tempReccurringEvent.calenderEventEndDate = new Date(this.endDate);
    this.tempReccurringEvent.startDate = this.tempReccurringEvent.startDate ? new Date(this.tempReccurringEvent.startDate + 'Z') : new Date(this.startDate);
    this.tempReccurringEvent.endDate = this.tempReccurringEvent.endDate ? new Date(this.tempReccurringEvent.endDate + 'Z') : null;
    if (this.tempReccurringEvent.endDate) {
      this.selectedEnd = 'End by';
    } else if (this.tempReccurringEvent.maxNoOfOccurrence) {
      this.selectedEnd = 'End after';
      this.tempReccurringEvent.maxNoOfOccurrence = this.counts.find(el => el.value == this.tempReccurringEvent.maxNoOfOccurrence);
    } else {
      this.selectedEnd = 'No end date';
    }
    this.displayCustom = true;
  }

  resetCustomRecurring() {
    this.displayCustom = false;
    this.tempReccurringEvent = {
      "id": 0,
      "createdSource": "",
      "updatedSource": "",
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.userId,
      "createdDate": new Date(),
      "updatedDate": new Date(),
      "calendarEventId": 0,
      "daysOfWeek": "",
      "dayOfMonth": 0,
      "monthOfYear": 0,
      "maxNoOfOccurrence": 0,
      "interval": 1,
      "firstDayOfWeek": "",
      "index": "",
      "startDate": this.startDate ? this.startDate : new Date(),
      "endDate": this.endDate ? this.endDate : new Date(),
      "statusId": Status.Active,
      "repeatTypeId": 0,
      "reminderInMinutes": 0,
      "calenderEventStartDate": null,
      "calenderEventEndDate": null
    }
    this.selectedCustomRepeat = this.repeats[0];
    this.selectedDayNumber = this.dayNumbers[0];
    this.selectedWeekNumber = this.weekNumbers[0];
    this.weekDays.forEach(elem => { elem.checked = false });
    this.monthDay1 = null;
    this.monthDay2 = null;
    this.selectedMonthWeek = null;
    this.selectedWeek = null;
    this.selectedYearNumber = null;
    this.selectedYear = null;
    this.selectedYearMonth = null;
    this.yearDay = null;
    this.selectedYearCount = null;
    this.selectedYearWeek = null;
    this.selectedYearMonth2 = null;
    this.selectedEnd = "End by";
  }

  saveCustomRecurring() {
    this.tempReccurringEvent.repeatTypeId = this.selectedCustomRepeat.id;
    if (this.selectedCustomRepeat.name === 'Daily') {
      //this.tempReccurringEvent.repeatTypeId = 1;
      if (this.selectedDay == 'Every day') {
        this.tempReccurringEvent.interval = this.selectedDayNumber.value || 1;
        this.tempReccurringEvent.daysOfWeek = "";
      } else if (this.selectedDay == 'Every weekday') {
        this.tempReccurringEvent.daysOfWeek = "Monday, Tuesday, Wednesday, Thursday, Friday";
        //this.tempReccurringEvent.interval = 0;
      }
    } else if (this.selectedCustomRepeat.name === 'Weekly') {
      //this.tempReccurringEvent.repeatTypeId = 2;
      this.tempReccurringEvent.interval = this.selectedWeekNumber.value;
      this.tempReccurringEvent.daysOfWeek = "";
      this.weekDays.forEach(elem => {
        if (elem.checked) {
          this.tempReccurringEvent.daysOfWeek = this.tempReccurringEvent.daysOfWeek ? this.tempReccurringEvent.daysOfWeek + ', ' + elem.name : elem.name;
        }
      });
    } else if (this.selectedCustomRepeat.name === 'Monthly') {
      //this.tempReccurringEvent.repeatTypeId = 3;
      if (this.selectedMonth == 'Day') {
        this.tempReccurringEvent.dayOfMonth = this.monthDay1;
        this.tempReccurringEvent.monthOfYear = this.monthDay2;
        this.tempReccurringEvent.index = "";
        this.tempReccurringEvent.daysOfWeek = "";
      } else if (this.selectedMonth == 'The') {
        this.tempReccurringEvent.index = this.selectedMonthWeek.value;
        this.tempReccurringEvent.daysOfWeek = this.selectedWeek.name;
        this.tempReccurringEvent.monthOfYear = this.monthDay1;
        this.tempReccurringEvent.dayOfMonth = 0;
      }
    } else if (this.selectedCustomRepeat.name === 'Yearly') {
      //this.tempReccurringEvent.repeatTypeId = 4;
      this.tempReccurringEvent.interval = this.selectedYearNumber.value;
      if (this.selectedYear == 'On') {
        this.tempReccurringEvent.monthOfYear = this.selectedYearMonth.value;
        this.tempReccurringEvent.dayOfMonth = this.yearDay;
      } else if (this.selectedYear == 'On the') {
        this.tempReccurringEvent.index = this.selectedYearCount;
        this.tempReccurringEvent.daysOfWeek = this.selectedYearWeek.name;
        this.tempReccurringEvent.monthOfYear = this.selectedYearMonth2.value;
      }
    } else {
      this.tempReccurringEvent.interval = 1;
      this.tempReccurringEvent.daysOfWeek = "";
      this.tempReccurringEvent.dayOfMonth = 0;
      this.tempReccurringEvent.monthOfYear = 0;
      this.tempReccurringEvent.index = ""
    }
    if (this.selectedEnd == 'End by') {
      this.tempReccurringEvent.maxNoOfOccurrence = 0;
    } else if (this.selectedEnd == 'End after') {
      this.tempReccurringEvent.endDate = null;
      this.tempReccurringEvent.maxNoOfOccurrence = this.tempReccurringEvent.maxNoOfOccurrence['value']
    } else if (this.selectedEnd == 'No end date') {
      this.tempReccurringEvent.maxNoOfOccurrence = 0;
      this.tempReccurringEvent.endDate = null;
    }

    this.changeMessage(this.selectedCustomRepeat.name);

    // Assign to main Json
    this.eventTemp.calendarEvent.reminderInMinutes = this.tempReccurringEvent.reminderInMinutes && this.tempReccurringEvent.reminderInMinutes['value'] ? this.tempReccurringEvent.reminderInMinutes['value'] : 0;
    delete this.tempReccurringEvent.reminderInMinutes;
    // this.eventTemp.calendarEvent.startDate = this.tempReccurringEvent.calenderEventStartDate && this.tempReccurringEvent.calenderEventStartDate ? this.tempReccurringEvent.calenderEventStartDate : null;
    this.startDate = this.tempReccurringEvent.calenderEventStartDate && this.tempReccurringEvent.calenderEventStartDate ? this.tempReccurringEvent.calenderEventStartDate : null;
    delete this.tempReccurringEvent.calenderEventStartDate;
    // this.eventTemp.calendarEvent.endDate = this.tempReccurringEvent.calenderEventEndDate && this.tempReccurringEvent.calenderEventEndDate ? this.tempReccurringEvent.calenderEventEndDate : null;
    this.endDate = this.tempReccurringEvent.calenderEventEndDate && this.tempReccurringEvent.calenderEventEndDate ? this.tempReccurringEvent.calenderEventEndDate : null;
    delete this.tempReccurringEvent.calenderEventEndDate;
    this.eventTemp.calendarEvent.recurrence = this.tempReccurringEvent;
    this.resetCustomRecurring();
  }

  setOnlineMeetings(type) {
    switch (type) {
      case 'Teams':
        this.eventTemp.calendarEvent.location = 'Microsoft Teams';
        this.eventTemp.calendarEvent.onlineMeetingProvider = 'teamsForBusiness';
        this.eventTemp.calendarEvent.isOnlineMeeting = true;
        this.eventTemp.calendarEvent.description = '<br><br><br><div>Please add event link here!</div>';
        break;
      default:
        break;
    }
  }
  showClick(e){
    e.overlayVisible = true;
    //this.search('');

  }

  //#region Associations

   //Manuall Selection
  displayManualPopup: boolean = false;
  manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
  selectedRecordList: any[] = [];
  selectedModule: any;
  //  selectedChannel: any;

  assignData() {
    this.displayManualPopup = true;
    this.selectedModule = this.taskModules.find(c=> c.id==this.eventTemp.objectTypeId);
    this.chooseAccountCol();
    const selectedList: any =  JSON.parse(JSON.stringify(this.eventTemp.objectId));
    this.selectedRecordList = this.eventTemp.objectId ? [...selectedList] : [];
  }

  saveAssignData($event) {
    const selectedList: any =  JSON.parse(JSON.stringify($event.selectedReccords));
    this.selectedRecordList = [...selectedList];
    if (this.selectedRecordList?.length > 0) {
      this.eventTemp.objectId = this.selectedRecordList?.[0]||null;
    }
    this.displayManualPopup = false;
  }


  resetAssociation(association){
    this.selectedRecordList = [];
    this.eventTemp.objectId =  null;
  }

  chooseAccountCol() {
      this.columnSettingsService.getColumnSettings(this.objectTypeId,this.eventTemp.channelId).subscribe(
          resp => {
              let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
              this.manualRuleColumnSetttings = defaultColumnSettings;
          },
          err => {
          }
      );
  }

  columnSettingSaved($event) {
    this.manualRuleColumnSetttings = $event;
  }

  manualpopupCancelClicked() {
    this.displayManualPopup = false;
  }

  //#endregion Associations
  onChangeModule(moduleId: number, clearData: boolean = false): void {

    if(clearData){
        this.associationNames = [];
        this.eventTemp.channelId = null;
        this.eventTemp.objectId = null;
    }

    switch (moduleId) {
      case LeadModuleId:
      case AccountModuleId:
        this.getLeadAccountChannel(moduleId);
        break;
      case OpportunityModuleId:
        this.getOpportunityCasesChannel(moduleId);
        break;
      case CaseModuleId:
        this.getCaseChannel(moduleId);
        break;
      default:
        this.getAssociationNames(moduleId);
        break;
    }
  }

  getLeadAccountChannel(objectId: number) {
    this.appMainService.isShowSpinner('getChannel');
    this.channelService.getChannels(objectId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response) => {
            this.channelsN = response || [];
            this.appMainService.isHideSpinner('getChannel');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getChannel');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
            });

          },
          complete: () => {
          },
        });
  }

  getOpportunityCasesChannel(objectId: number) {
    this.appMainService.isShowSpinner('getChannel')
    this.channelService.getAllChannels(objectId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response) => {
            this.channelsN = response || [];
            this.appMainService.isHideSpinner('getChannel');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getChannel');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
            });

          },
          complete: () => {
          },
        });
  }

  getCaseChannel(objectId: number) {
    this.appMainService.isShowSpinner('getChannel');
    this.channelService.getAllChannels(objectId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        {
          next: (response) => {
            this.channelsN = response || [];
            this.appMainService.isHideSpinner('getChannel');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getChannel');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
            });

          },
          complete: () => {
          },
        });
  }

  setModuleDetails(selectedChannel?: number) {
    if (this.eventFromModule && this.selectedObject) {
      const selectedAssociation = [{
        id: this.selectedObject?.id, businessName: this.selectedObject?.businessName || this.selectedObject?.name || this.selectedObject?.associationName
      }];
      const channelId: number = this.selectedObject?.typeId || this.selectedObject?.pipelineId || this.selectedObject?.channelId || this.selectedChannel?.id || 0;
      this.eventTemp.channelId = channelId;
      this.onChangeModule(this.eventTemp.objectTypeId);
      this.onChangeChannel(channelId);
    } else if (this.eventTemp.objectTypeId) {
      this.onChangeModule(this.eventTemp.objectTypeId);
    }
  }

  onChangeChannel(channelId: number, clearData: boolean = false) {
    this.getAssociationNames(this.eventTemp.objectTypeId);
    if (clearData) {
      this.associationNames = [];
      this.eventTemp.objectId = null;
    }
    this.selectedChannelForEvent = {id: channelId};
  }

}
